import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    activate: {
      description: 'You must activate the card in order to use it.',
      title: 'Activate my card',
    },
    delete: {
      description:
        "This card will be permanently deleted, it won't be possible to reactivate it.",
      title: 'Delete this virtual card',
    },
    lock: {
      description: 'You can lock this card to prevent fraudulent uses.',
      title: 'Just lock the card temporarily',
    },
    lockOptions: {
      description:
        'Prevent fraudulent uses of this card. You can unlock it at any time.',
      title: 'Lock Card',
    },
    markAsLost: {
      description:
        'This card will be permanently locked. You can order a new one right away',
      title: 'I lost my card',
    },
    markAsStolen: {
      description:
        'This card will be permanently locked. You can order a new one right away.',
      title: 'My card was stolen',
    },
    orderNewPhysicalCard: {
      description: 'Your current card will be permanently deleted.',
      title: 'Order a new card',
    },
    requestNewPhysicalCard: {
      description: 'Your current card will be permanently deleted.',
      title: 'Request a new card',
    },
    unblockPin: {
      description:
        'The PIN was blocked after too many wrong attempts. Unblock it here.',
      title: 'Unblock PIN',
    },
    unlock: {
      description:
        'This card was locked temporarily. Unlock it now so you can use it again.',
      title: 'Unlock Card',
    },
    updatePin: {
      description: 'Change your PIN in an instant at all time.',
      title: 'Change my PIN',
    },
  },
  fr: {
    activate: {
      description: "Vous devez activer la carte pour pouvoir l'utiliser.",
      title: 'Activer ma carte bancaire',
    },
    delete: {
      description:
        'Cette carte sera définitivement supprimée, il est impossible d’annuler cette action.',
      title: 'Supprimer cette carte virtuelle',
    },
    lock: {
      description:
        'Si vous voulez juste être prudent et bloquer cette carte bancaire temporairement.',
      title: 'Bloquer temporairement',
    },
    lockOptions: {
      description:
        'Évitez toute utilisation frauduleuse de cette carte bancaire. Vous pouvez la débloquer à tout moment.',
      title: 'Bloquer ma carte bancaire',
    },
    markAsLost: {
      description:
        'Cette carte bancaire sera définitivement bloquée. Vous pouvez en commander une nouvelle dès maintenant.',
      title: "J'ai perdu ma carte bancaire",
    },
    markAsStolen: {
      description:
        'Cette carte bancaire sera définitivement bloquée. Vous pouvez en commander une nouvelle dès maintenant.',
      title: 'Ma carte bancaire a été volée',
    },
    orderNewPhysicalCard: {
      description: 'Votre carte bancaire actuelle sera définitivement bloquée.',
      title: 'Commander une nouvelle carte',
    },
    requestNewPhysicalCard: {
      description: 'Votre carte bancaire actuelle sera définitivement bloquée.',
      title: 'Demander une nouvelle carte',
    },
    unblockPin: {
      description:
        'Le code PIN a été bloqué après plusieurs essais infructueux. Débloquez-le ici.',
      title: 'Débloquer le code PIN',
    },
    unlock: {
      description:
        "Nous avons temporairement bloqué cette carte bancaire. Débloquez-la pour pouvoir l'utiliser à nouveau.",
      title: 'Débloquer ma carte bancaire',
    },
    updatePin: {
      description: 'Réinitialiser le code PIN et en créer un nouveau.',
      title: 'Changer le code PIN',
    },
  },
} as const);
